/**
 * Where a navigation was started, for nav-tracker's rows (metadata.nav_source).
 *
 * The main menu, the phone drawer and the Community pill bar mark their click just before they
 * navigate; nav-tracker reads the mark once for the navigation that follows. Anything unmarked is a
 * deep link (typed URL, in-page link, notification). Kept apart from nav-tracker so these components
 * don't import the tracker's API client.
 */
export type NavSource = 'menu' | 'drawer' | 'pill' | 'deeplink';

let pending: Exclude<NavSource, 'deeplink'> | null = null;

export function markNavSource(source: Exclude<NavSource, 'deeplink'>): void {
  pending = source;
}

/** Read once and clear, so a mark belongs to exactly one navigation. */
export function consumeNavSource(): NavSource {
  const s = pending ?? 'deeplink';
  pending = null;
  return s;
}
